import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Landing from "@/pages/Landing";
import StaticPage from "@/pages/StaticPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/contact" element={<StaticPage slug="contact" />} />
        <Route path="/shipping" element={<StaticPage slug="shipping" />} />
        <Route path="/returns" element={<StaticPage slug="returns" />} />
        <Route path="/privacy" element={<StaticPage slug="privacy" />} />
        <Route path="/terms" element={<StaticPage slug="terms" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
